<div class="testimonial_content" *ngIf="testimonydata != undefined">
    <h1 class="title text-center">Testimonial</h1>
    <div class="sliderContent mt-4">
        <div id="carouselExampleIndicators" class="carousel slide">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" *ngFor="show of testimonydata; let i = index"
                [attr.data-bs-slide-to]="i" [ngClass]="{'active' : i == 0}" aria-current="true" aria-label="Slide 1"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let a of testimonydata ; let i = index" [ngClass]="{'active': i === 0}">
                    <div class="subContent">                       
                        <div class="testiMonial_img_content mt-5">
                            <div class="testiMonial_img">
                                <img src={{a.files[0].url}} alt="" class="testiMonial_img">
                            </div>
                            <div class="img_text">{{a.Title}}</div>
                            
                        </div>
                        <div class="testimonial_text">
                            {{a.Short}}
                         </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</div>
